import React, { useCallback, useState } from 'react';
import { AsoScenarioStoreTierResponse } from '@ydistri/api-sdk';
import { useStableParams } from '../../../../routes/useStableParams';
import { useUpdateAsoStoreTierMutation } from '../../apiAso';
import StoreTierSelector from '../StoreTierSelector/StoreTierSelector';
import { useAsoScenarioStatus } from '../../hooks/useAsoScenarioStatus';

interface StoreTierSetterProps {
  tier: Pick<AsoScenarioStoreTierResponse, 'storeId' | 'computedTier' | 'forcedTier'>;
}

const StoreTierSetter: React.FC<StoreTierSetterProps> = ({ tier }) => {
  const { asoScenarioId } = useStableParams();
  const [updateTier, { isLoading }] = useUpdateAsoStoreTierMutation();
  const [localForced, setLocalForced] = useState<number | undefined | null>(tier.forcedTier);
  const { isLocked } = useAsoScenarioStatus();

  const usedValue = localForced ?? tier.computedTier;

  const onChange = useCallback(
    (newTier: number) => {
      if (isLocked) return;
      setLocalForced(newTier);
      if (asoScenarioId) {
        updateTier({
          asoScenarioId,
          storeId: tier.storeId,
          payload: { forcedTier: newTier },
        });
      }
    },
    [asoScenarioId, tier.storeId, updateTier, isLocked],
  );

  const onReset = useCallback(() => {
    if (isLocked) return;
    setLocalForced(null);
    if (asoScenarioId) {
      updateTier({
        asoScenarioId,
        storeId: tier.storeId,
        payload: { forcedTier: null },
      });
    }
  }, [asoScenarioId, tier.storeId, updateTier, isLocked]);

  return (
    <StoreTierSelector
      value={usedValue}
      forcedValue={localForced}
      onChange={onChange}
      onReset={onReset}
      disabled={isLoading || isLocked}
      computedValue={tier.computedTier}
    />
  );
};

export default StoreTierSetter;
